import React from "react"
import { useNavigate } from "react-router-dom"
import { isObject } from "lodash"
import PropTypes from "prop-types"

// styles
import "./ErrorNotification.scss"

const ErrorNotification = ({ error }) => {
  const navigate = useNavigate()

  const formatError = () => {
    if (isObject(error?.response?.data?.error.details)) {
      let msg = error.response.data.error?.msg || ""
      let msgs = []
      if (msg) msgs.push(msg)

      Object.keys(error.response.data.error.details).forEach((key) => {
        if (Array.isArray(error.response.data.error.details[key])) {
          error.response.data.error.details[key].forEach((msg) => {
            if (typeof msg === "string") {
              msgs.push(msg)
            }
          })
        }
      })
      return msgs.join("\n")
    } else if (error?.response?.data?.error.details?.msg) {
      return error.response.data.error.details.msg
    } else if (error.response?.data?.error?.msg) {
      return error.response.data.error.msg
    }

    return
  }

  if (error)
    return (
      <div className="login-notification-container error-notif">
        <i className="fas fa-exclamation-triangle" />
        <div>
          <div className="login-error-text">{formatError()}</div>
          {error?.response?.data?.error?.msg === "Your password has expired." && (
            <a
              className="login-error-text-link"
              onClick={() => navigate("/forgot-password")}
            >
              Please reset your password here.
            </a>
          )}
        </div>
      </div>
    )
  return
}

ErrorNotification.propTypes = {
  error: PropTypes.string,
}

export default ErrorNotification
